import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticClass: "pa-0 ma-0"
  }, [_c(VCol, {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "8"
    }
  }, [_c('h5', {
    attrs: {
      "data-cy": "packet_visualization"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.packetVisualisation')) + "\n      ")])]), _c(VCol, {
    staticClass: "pa-0 ma-0",
    attrs: {
      "cols": "4",
      "align": "right"
    }
  }, [_vm.shouldShowParsedData ? _c(VBtnToggle, {
    attrs: {
      "rounded": "",
      "color": _vm.color,
      "mandatory": "",
      "dense": ""
    },
    model: {
      value: _vm.displayType,
      callback: function ($$v) {
        _vm.displayType = $$v;
      },
      expression: "displayType"
    }
  }, [_c(VBtn, {
    attrs: {
      "value": "parsed",
      "data-cy": "parsed_btn"
    }
  }, [_vm._v("Parsed")]), _c(VBtn, {
    attrs: {
      "value": "raw",
      "data-cy": "raw_btn"
    }
  }, [_vm._v("Raw")])], 1) : _vm._e()], 1)], 1), _c(VCard, {
    staticClass: "dt-card-text-01 outer-card",
    attrs: {
      "height": _vm.height
    }
  }, [_vm.hasNoPacketData ? [_c('div', {
    staticClass: "empty-state",
    attrs: {
      "data-cy": "empty_state_message"
    }
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("fal fa-comment-exclamation")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.details.noPacketSelected')) + "\n      ")], 1)] : [(_vm.displayType === 'parsed' ? _vm.parsedData : _vm.data) ? _c('json-viewer', {
    attrs: {
      "value": _vm.displayType === 'parsed' ? _vm.parsedData : _vm.data,
      "expand-depth": 4,
      "expanded": "",
      "data-cy": "json_viewer"
    }
  }) : _vm._e()]], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };